/**
 * Simple logger function for shared package
 * For full logger, use the one from apps/api
 */

export const logger = (namespace: string) => {
  return (...args: unknown[]) => {
    if (typeof process !== "undefined" && process.env && process.env.DEBUG) {
      console.log(`[${namespace}]`, ...args);
    }
  };
};
